/**
 * Валидация ввода времени в поле "Удобное время для звонка".
 * @param {HTMLFormElement} form
 */
export default function validateTime(form) {
  const convenientTime = form.querySelector('.form_for_callTime');
  const errLabelElement = form.querySelector('.time-format--error');
  const timeItem = form.querySelector('.time-back-call');
  if (!timeItem.closest('.form_for_callTime.active')) {
    return true;
  }
  // Диапазон времени работы диспетчерской службы.
  // Вне этого диапазона не может быть заказан звонок.
  const { start, end } = convenientTime.dataset;
  // Введённое пользователем время
  const selectTime = form.querySelector('input.time-back-call').value;
  const timeRegExp = /^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]/;
  // Проверка валидности введённого значения для диапазона [00:00 - 23:59];
  if (!timeRegExp.test(selectTime)) {
    changeVisible(errLabelElement, true, 'Ошибка: некорректно указано время');
    return false;
  }
  changeVisible(errLabelElement, false);
  // Введённое время не попало в диапазон, доступный для записи.
  const inRange = isInRange(selectTime, [start, end]);
  if (!inRange) {
    changeVisible(errLabelElement, true, 'К сожалению, мы не сможем перезвонить вам в указанное время.');
    return false;
  }

  changeVisible(errLabelElement, false);
  return true;
}

/**
 * Проверка, попало ли введённое время пользователем, в диапазон range.
 * @param {string} value проверяемое время. Пример '12:23'.
 * @param {Array} range диапазон времени. Пример: ['09:00', '13:00'].
 * @returns {boolean}
 */
function isInRange(value, range) {
  const re = /^(([0-1][0-9])|(2[0-3])):[0-5][0-9]$/;
  const [start, end] = range;
  // Validate values
  if ([value, start, end].some((v) => !re.test(v))) {
    return false;
  }

  // If start less than end, assume doesn't go over midnight
  if (start <= end) {
    return value >= start && value < end;

    // Otherwise, assume goes over midnight
  }

  return value >= start || value < end;
}

/**
 *
 * @param {HTMLFormElement} element
 * @param {boolean} show
 * @param {string} message
 */
function changeVisible(element, show, message = '') {
  if (show) {
    // К сожалению, мы не сможем перезвонить вам в указанное время.
    // Ошибка: некорректно указано время
    element.style.display = 'block';
    element.querySelector('label').innerHTML = message;
    element.closest('.form-item').classList.add('err-item-call-back');
  } else {
    element.style.display = 'none';
    element.querySelector('label').innerHTML = 'asd1';
    element.closest('.form-item').classList.remove('err-item');
    element.closest('.form-item').classList.remove('err-item-call-back');
  }
}
